var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-overlay',{attrs:{"value":_vm.openOverlay,"opacity":"1","color":"#212121"}},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary","size":"100","width":"4"}},[_c('v-img',{staticClass:"logo",attrs:{"eager":"","src":require('@/assets/img/logo_loader.png'),"height":"80","contain":""}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }